import { createApp } from 'vue';
import App from './App.vue';
import './assets/css/base.css';
import 'normalize.css';
import 'animate.css';

createApp(App).mount('#app');
